import { ActionButtonProps, Box, BoxProps, ColorOptions, Form } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { FC, useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../data/store'
import { formData } from './formData'

interface MerchantFormProps {
  id: any
  onUpdate?: any
  isEditable: boolean
  isDeletable: boolean
  onClose?: () => void
}

const FormBox = ({ children }: any) => {
  return <Box {...styles.formContainer}>{children}</Box>
}

const MerchantForm: FC<MerchantFormProps> = (props: MerchantFormProps) => {
  const { id, onUpdate, isEditable, isDeletable } = props

  const [toggle, setToggle] = useState(false)

  const { entityData, entityIdMap, addMP, updateMP, message } = useStores((store) => ({
    entityData: store.processingEntity.getEntity,
    entityIdMap: store.entityMaster.getEntityMap(),
    addMP: store.processingEntity.addProcessingEntity,
    updateMP: store.processingEntity.updateProcessingEntity,
    message: store.message.getFormMessage(),
  }))

  const [lazyAdd, lazyAddHandler] = useLazyApiData(addMP)
  const [lazyUpdate, lazyUpdateHandler] = useLazyApiData(updateMP)

  useEffect(() => {
    if (lazyAddHandler.state === 'fulfilled') {
      onUpdate && onUpdate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyAddHandler])

  useEffect(() => {
    if (lazyUpdateHandler.state === 'fulfilled') {
      onUpdate && onUpdate()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyUpdateHandler])

  const addMerchant = (values: any) => {
    lazyAdd(values)
  }

  const updateMerchant = (values: any) => {
    lazyUpdate({ id, ...values })
  }

  const onDismiss = () => {
    setToggle(false)
  }

  const deleteMerchant = () => {
    setToggle(true)
  }

  const handleActions = ({ values, title, defaultActionButtonOnSubmit, resetForm, isValid }: ActionButtonProps) => {
    const handleOnPress = () => {
      defaultActionButtonOnSubmit()
    }

    return (
      <Box pv={16} flexDirection="row" align={'center'} justify={'center'}>
        {isEditable && (
          <ButtonNew
            title={id ? 'Update' : title}
            onPress={handleOnPress}
            height={40}
            color={'#214796'}
            titleColor={'WHITE'}
            textType={'body14'}
            width={280}
            disabled={!isValid}
            isLoading={lazyAddHandler.state === 'pending' || lazyUpdateHandler.state === 'pending'}
          />
        )}
      </Box>
    )
  }

  return (
    <Box>
      <Form
        initialValues={id ? entityData(id, true) : {}}
        formData={formData(id, addMerchant, updateMerchant, entityIdMap, isEditable, message)}
        actionButtons={handleActions}
        container={FormBox}
      />
    </Box>
  )
}

export { MerchantForm }

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  formContainer: {
    underlayColor: 'WHITE',
    bg: 'WHITE',
    padding: 'MEDIUM',
    backgroundColor: 'WHITE',
    minWidth: 300,
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: '#e3e6f0' as ColorOptions,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    ...shadow,
  } as BoxProps,
}
